import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  CmpSelectField,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import { GridToolbar } from "@mui/x-data-grid";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import {
  common_brandbasedgroup_GETROW,
  common_brandgroup_GETROW,
  common_groupstructure_GETROW,
  ILSTCRA_ILSTCRB_Update,
  ILSTCR_Items_Master_GetRow,
} from "../../Server/ApiV2";
import GCAutocompleteCheckboxFixSize from "../../Component/Common/ReuseableComponent/GCAutocompleteCheckboxFixSize";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import moment from "moment";
import { ItemListRequestRO } from "../../Redux/roStore";
import { useDispatch, useSelector } from "react-redux";
import { Head_Set } from "./SliceItemListingDetail";
import "./ItemListingRequest.css";
import CycleCustomModal from "../../Component/Common/ReuseableComponent/CycleCustomModal";
import ItemSearchModal from "../StockSetupChangeRequest/ItemSearchModal";
import { DataGridPro } from "@mui/x-data-grid-pro";
import GCBrandSearch from "../../Component/Common/ReuseableComponent/GCBrandSearch";
import { fExecuteAPI } from "../../Server/Apis";
import GCToggleSearchV1 from "../../Component/Common/ReuseableComponent/GCToggleSearchV1";
const FilterModal = ({
  vMediaQuery,
  xMediaQuery,
  fLoadDetail,
  handleClose,
}) => {
  const sWebStockReportData = [
    { Uid: "All", Value: "ALL" },
    { Uid: "Is", Value: "Is" },
  ];

  const [sMainGroupData, setMainGroupData] = useState([]);
  const [sCategoryData, setCategoryData] = useState([]);
  const [sSubGroupData, setSubGroupData] = useState([]);
  const [sMainSupplierData, setMainSupplierData] = useState([]);
  const [sBrandData, setBrandData] = useState([]);
  const [sBrandCategoryData, setBrandCategoryData] = useState([]);
  const [row, setRow] = useState([]);
  const [originalRowData, setOriginalRowData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });
  const HeadObjectInit = {
    // sLocation: "Is",
    sMainGroup: "All",
    sSubGroup: "All",
    sCategory: "All",
    sMainSupplier: "All",
    sBrand: "All",

    sLocationArr: [],
    sLocationPrnt: "",
    sLocationCode: "",
    sLocationName: "",
    sMainGroupArr: [],
    sMainGroupPrnt: "",
    sMainGroupCode: "",
    sMainGroupName: "",
    sSubGroupArr: [],
    sSubGroupPrnt: "",
    sSubGroupCode: "",
    sSubGroupName: "",
    sCategoryArr: [],
    sCategoryPrnt: "",
    sCategoryCode: "",
    sCategoryName: "",
    sMainSupplierArr: [],
    sMainSupplierPrnt: "",
    sMainSupplierCode: "",
    sMainSupplierName: "",
    sBrandArr: [],
    sBrandPrnt: "",
    sBrandCode: "",
    sBrandName: "",
    sBrandCategoryArr: [],
    sBrandCategoryPrnt: "",
    sBrandCategoryCode: "",
    sBrandCategoryName: "",
    dateFrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    dateTo: new Date(),
    dcItemOnly: "B",
    deleteInsert: "N",

    sBrandSearchValue: "",
  };
  const [masterData, setMasterData] = useState(HeadObjectInit);

  const [isEditing, setIsEditing] = useState(false);

  const transObj = useSelector(
    (state) => state.SliceItemListRequest.value.Head
  );

  const dispatch = useDispatch();

  console.log("masterData : ", masterData);

  //click anywhere to close the toggle
  useEffect(() => {
    const handleClick = (event) => {
      // For item name toggle
      if (sItemToggleDropdown) {
        const itemToggleElement = event.target.closest(".toggleSearch");
        if (!itemToggleElement) {
          setItemToggleDropdown(false);
        }
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sItemToggleDropdown]);

  const fWmsStockRepotArr = async (xGroupStructureObj, setGroupData) => {
    let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
    const CurrentMaingroupArr = await common_groupstructure_GETROW(FinalObj);
    if (CurrentMaingroupArr?.status === 200) {
      setGroupData(CurrentMaingroupArr?.data?.ResultSet);
    }
  };

  const fMainGroup = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      sMainGroup: e.target.value,
      sMainGroupArr: [],
      sMainGroupPrnt: "",
      sMainGroupName: "",
      sSubGroup: "All",
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));
    setSubGroupData([]);
    setCategoryData([]);

    if (e.target.value.toUpperCase() == "ALL") {
      setMainGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj = {
        Prnt: "",
        Lvl: "1",
      };
      await fWmsStockRepotArr(xGroupStructureObj, setMainGroupData);
    }
  };

  const fSubGroup = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));

    setCategoryData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setSubGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      const mainGrpData = masterData?.sMainGroupArr
        .map((item) => `${item}`)
        .join(",");
      let xGroupStructureObj2 = {
        Prnt: mainGrpData,
        Lvl: "2",
      };
      await fWmsStockRepotArr(xGroupStructureObj2, setSubGroupData);
    }
  };

  const fCategory = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));

    if (e.target.value.toUpperCase() == "ALL") {
      setCategoryData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      const subGrpData = masterData?.sSubGroupArr
        .map((item) => `${item}`)
        .join(",");
      let xGroupStructureObj2 = {
        Prnt: subGrpData,
        Lvl: "3",
      };

      await fWmsStockRepotArr(xGroupStructureObj2, setCategoryData);
    }
  };

  const GetWmsStockRepotBrand = async (setGroupData) => {
    const CurrentMaingroupArr = await common_brandgroup_GETROW("");
    if (CurrentMaingroupArr?.status === 200) {
      setGroupData(CurrentMaingroupArr?.data?.ResultSet);
    }
  };
  const fBrand = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sBrandArr: [],
      sBrandPrnt: "",
      sBrandName: "",
      sBrandCategoryArr: [],
      sBrandCategoryPrnt: "",
      sBrandCategoryCode: "",
      sBrandCategoryName: "",
    }));
    setBrandCategoryData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setBrandData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotBrand(setBrandData);
    }
  };

  const fWmsStockRepotBrandArr = async (xGroupStructureObj, setGroupData) => {
    let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
    const CurrentMaingroupArr = await common_brandbasedgroup_GETROW(FinalObj);
    if (CurrentMaingroupArr?.status === 200) {
      setGroupData(CurrentMaingroupArr?.data?.ResultSet);
    }
  };

  const getCyclicCountItemGetRow = async () => {
    const HeadObject = ItemListRequestRO();

    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    const mainGrpData = masterData?.sMainGroupArr
      .map((item) => `${item}`)
      .join(",");
    const subGrpData = masterData?.sSubGroupArr
      .map((item) => `${item}`)
      .join(",");
    const catGrpData = masterData?.sCategoryArr
      .map((item) => `${item}`)
      .join(",");
    const suplGrpData = masterData?.sMainSupplierArr
      .map((item) => `${item}`)
      .join(",");
    const brandGrpData = masterData?.sBrandArr.map((x) => x.UID).join(", ");

    if (HeadObject?.Head?.A_Location === "") {
      fAlertToast("INFO", "Location should not be empty");
      return;
    }

    if (masterData?.dateFrom === "") {
      fAlertToast("INFO", "From Date should not be empty");
      return;
    }

    if (masterData?.dateTo === "") {
      fAlertToast("INFO", "To Date should not be empty");
      return;
    }

    // if (HeadObject?.Head?.VendorCd === "") {
    //   fAlertToast("INFO", "Vendor should not be empty");
    //   return;
    // }

    try {
      const obj = {
        v_MainGrp: mainGrpData,
        v_SubGrp: subGrpData,
        v_Grp: catGrpData,
        v_BrandCd: brandGrpData,
        v_Supplier: suplGrpData,
        v_Loc: HeadObject?.Head?.A_Location,
        v_Date1: moment(masterData?.dateFrom).format("MM/DD/YYYY"),
        v_Date2: moment(masterData?.dateTo).format("MM/DD/YYYY"),
        v_ItmCd: detailObj.itemCode,
       // v_Vendor: HeadObject?.Head?.VendorCd,
      };

      const response = await ILSTCR_Items_Master_GetRow(obj);
      if (response?.status === 200) {
        loader.style.display = "none";
        setRow(response?.data?.ResultSet);
        setOriginalRowData(response?.data?.ResultSet);
      } else {
        fAlertToast(
          "FAILED",
          `${response?.message || "Internal Server Error"}`
        );
        console.error("Error response: ", response);
      }
    } catch (error) {
      loader.style.display = "none";
    }
  };
  console.log("masterData", row);

  console.log("selectedRows", selectedRows);

  const HeadObject = ItemListRequestRO();

  const fSave = async () => {
    if (selectedRows.length == 0) {
      fAlertToast("FAILED", "LineItems should not be empty");
      return;
    }

    const vRdxUserInfoObj = ItemListRequestRO();

    if (HeadObject?.Head?.A_Location == "") {
      fAlertToast("INFO", "Location should not be empty");
      return;
    }

    // if (transObj.VendorName == "") {
    //   fAlertToast("INFO", "Vendor should not be empty");
    //   return;
    // }

    // if (transObj.VendorCd == "") {
    //   fAlertToast("INFO", "Vendor should not be empty");
    //   return;
    // }

    if (HeadObject?.Head?.A_Date == "") {
      fAlertToast("INFO", "Date should not be empty");
      return;
    }

    if (HeadObject?.Head?.A_Location == "") {
      fAlertToast("INFO", "Location should not be empty");
      return;
    }

    const items = selectedRows?.map((item) => ({
    //  B_Srno: 0,
      B_Itemcd: item.ItmCd,
      B_Barcode: item.Barcode,
      Old_Listing: item.DisContinued,
      New_Listing: item.DisContinuedEdit,
    }));

    if (items?.length == 0) {
      fAlertToast("INFO", "LineItem should not be empty");
      return;
    }

    var obj = {
      A_TransId: HeadObject?.Head?.A_Transid,
      A_Date: moment(HeadObject?.Head?.A_Date).format("MM/DD/YYYY"),
      A_Loc: HeadObject?.Head?.A_Location,
      A_Narration: HeadObject?.Head?.A_Narration,
      A_UserCd: vRdxUserInfoObj?.UserID,
     //A_Vendor: HeadObject?.Head?.VendorCd,
      DeleteInsert: masterData?.deleteInsert,
      Items: items,
      isApproved: false,
    };

    console.log("obj", obj);
    console.log("HeadObj", HeadObject);

    const StockResponse = await ILSTCRA_ILSTCRB_Update(obj);
    if (StockResponse?.status === 200) {
      fAlertToast("SUCCESS", "Saved Successfully");
      fLoadDetail(StockResponse?.data?.ResultSet[0]?.A_Transid);
      dispatch(
        Head_Set({
          ...transObj,
          A_Transid: StockResponse?.data?.ResultSet[0]?.A_Transid,
        })
      );
      handleClose();
      setRow([]);
      setSelectedRows([]);
    }
  };

  useEffect(() => {
    if (masterData.sBrandArr.length > 0) {
      fetchBrandCategory();
    }
  }, [masterData.sBrandArr]);

  useEffect(() => {
    setMasterData((prev) => ({
      ...prev,
      sSubGroup: "All",
      sSubGroupArr: [],
    }));
  }, [masterData.sMainGroupArr]);

  useEffect(() => {
    setMasterData((prev) => ({
      ...prev,
      sCategory: "All",
      sCategoryArr: [],
    }));
  }, [masterData.sSubGroupArr]);

  const fetchBrandCategory = async () => {
    const subGrpData = masterData?.sBrandArr.map((item) => `${item}`).join(",");
    let xGroupStructureObj = {
      grp: subGrpData,
    };
    await fWmsStockRepotBrandArr(xGroupStructureObj, setBrandCategoryData);
  };

  const handleFieldEdit = (params, value, fieldName, parser = (v) => v) => {
    const currentRowIndex = row.findIndex((r) => r.Id === params.row.Id);
    const originalRow = originalRowData.find((r) => r.Id === params.row.Id);

    const updatedRow = {
      ...row[currentRowIndex],
      [fieldName]: parser(value),
    };

    const newRowData = [...row];
    newRowData[currentRowIndex] = updatedRow;
    setRow(newRowData);

    setEditedFieldsMap((prev) => ({
      ...prev,
      [params.row.Id]: {
        ...(prev[params.row.Id] || {}),
        [fieldName]: true,
      },
    }));

    let updatedSelectedRows = [...selectedRows];
    const rowExistsIndex = updatedSelectedRows.findIndex(
      (r) => r.Id === updatedRow.Id
    );

    const fieldsToCompare = ["DisContinuedEdit"];

    const isDifferent = fieldsToCompare.some(
      (field) => updatedRow[field] !== originalRow[field]
    );

    if (isDifferent) {
      if (rowExistsIndex === -1) {
        updatedSelectedRows.push(updatedRow);
      } else {
        updatedSelectedRows[rowExistsIndex] = updatedRow;
      }
    } else {
      if (rowExistsIndex !== -1) {
        updatedSelectedRows.splice(rowExistsIndex, 1);
      }
    }

    setSelectedRows(updatedSelectedRows);
    return updatedRow;
  };

  const yesNoOptions = [
    { Uid: "Y", Name: "Yes" },
    { Uid: "N", Name: "No" },
  ];

  const handleCheckboxChange = (name) => {
    setMasterData((prev) => ({
      ...prev,
      [name]: prev[name] === "Y" ? "N" : "Y",
    }));
  };

  const [editedFieldsMap, setEditedFieldsMap] = useState({});

  // Item Code Item Name

  const [searchModal, setSearchModal] = useState(false);

  let detailInitObj = {
    itemCode: "",
    itemName: "",
  };

  const [detailObj, setDetailObj] = useState(detailInitObj);

  let initError = {
    itemCode: "",
    itemName: "",
  };

  const [errors, setErrors] = useState(initError);

  const handleDetailChange = (field, value, event = null) => {
    setDetailObj((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const columnGroupingModel = [
    {
      groupId: "Discontinued",
      headerName: "Discontinued",
      children: [{ field: "DisContinued" }, { field: "DisContinuedEdit" }],
    },
  ];
  const fItemSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        detailObj?.itemName,
        transObj?.A_Location
      );
      if (vItemSearchFull.length > 0) {
        // set item name and item code
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace" && detailObj?.itemCode) {
      handleDetailChange("itemCode", "");
      handleDetailChange("itemName", "");
    }
  };
  const fGCToggleItemOnRowClick = async (e) => {
    handleDetailChange("itemCode", e?.row?.ItmCd);
    handleDetailChange("itemName", e?.row?.Name1);
    setItemToggleDropdown(false);
  };
  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        transObj?.A_Location,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const fItemToggleClick = () => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: detailObj?.itemName,
    }));

    if (detailObj?.itemName != "") {
      GetSearchItem(
        detailObj?.itemName,
        "Any",
        transObj?.A_Location,
        setGridSelectRowData
      );
    }

    handleClick();
  };

  const handleClick = () => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);

      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  };

  const GetItemFullSearchArr = async (xItemName, xLoc) => {
    let vItemFullSearchDataObj = {
      anyData: xItemName,
      transType: "F",
      report: "Y",
      loc: xLoc,
    };

    const vItemSearchFull = await fExecuteAPI(
      // "ITEM_SEARCHFULL_GETROW",
      "SEARCHEXACTITEM_GETROW",
      vItemFullSearchDataObj
    );
    //status code "" so Success is checked
    if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
      if (vItemSearchFull?.ResultSet?.length > 0) {
        return vItemSearchFull.ResultSet;
      } else {
        return [];
      }
    } else {
      fAlertToast(
        "FAILED",
        vItemSearchFull?.Type?.response?.data?.message
          ? vItemSearchFull?.Type?.response?.data?.message
          : "Error in vItemSearchFullArr"
      );
      return [];
    }
  };
  const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
    let vSeatchVendor = {
      Data: xData,
      Type: xType,
      Loc: xA_Loc,
      v_Vendor: HeadObject?.Head?.VendorCd || "",
    };
    const vItemSearch = await fExecuteAPI(
      "SEARCHITEM001_GETROW",
      vSeatchVendor
    );
    if (vItemSearch?.Type?.toUpperCase() == "SUCCESS") {
      let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setSearchGridData(vItemSearchArr);
    } else {
      fAlertToast(
        "FAILED",
        vItemSearch.response.data.message
          ? vItemSearch.response.data.message
          : "Error in SearchItem"
      );
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      // For item name toggle
      if (sItemToggleDropdown) {
        const itemToggleElement = event.target.closest(".toggleSearch");
        if (!itemToggleElement) {
          setItemToggleDropdown(false);
        }
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [sItemToggleDropdown]);

  return (
    <Box sx={{ paddingY: 1, paddingX: 0 }}>
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0.5, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={2.5} sm={2} md={1} lg={1}>
              <CmpTypographyField xcomponent={"span"} xText={"Main Group"} />
            </Grid>
            <Grid item xs={2} sm={2} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"03"}
                xLabelText="sMainGroup"
                xValue={masterData.sMainGroup}
                xOnChange={fMainGroup}
                xName={"sMainGroup"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={7.5} sm={8} md={6} lg={5}>
              <GCAutocompleteCheckboxFixSize
                options={sMainGroupData}
                xValue={masterData.sMainGroupArr}
                xtabIndex={"04"}
                xDisabled={
                  masterData?.sMainGroup?.toUpperCase() === "ALL" ? true : false
                }
                setValue={setMasterData}
                objName="sMainGroupArr"
                label=""
                placeholder="Search Main Group"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={2.5} sm={2} md={1} lg={1}>
              <CmpTypographyField xcomponent={"span"} xText={"Sub Group"} />
            </Grid>
            <Grid item xs={2} sm={2} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"05"}
                xLabelText="sSubGroup"
                xValue={masterData.sSubGroup}
                xOnChange={fSubGroup}
                xName={"sSubGroup"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={7.5} sm={8} md={6} lg={5}>
              <GCAutocompleteCheckboxFixSize
                options={sSubGroupData}
                xValue={masterData.sSubGroupArr}
                xtabIndex={"06"}
                xDisabled={
                  masterData?.sSubGroup?.toUpperCase() === "ALL" ? true : false
                }
                setValue={setMasterData}
                objName="sSubGroupArr"
                label=""
                placeholder="Search Sub Group"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={2.5} sm={2} md={1} lg={1}>
              <CmpTypographyField xcomponent={"span"} xText={"Category"} />
            </Grid>
            <Grid item xs={2} sm={2} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"07"}
                xLabelText="sCategory"
                xValue={masterData.sCategory}
                xOnChange={fCategory}
                xName={"sCategory"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={7.5} sm={8} md={6} lg={5}>
              <GCAutocompleteCheckboxFixSize
                options={sCategoryData}
                xValue={masterData.sCategoryArr}
                xtabIndex={"08"}
                xDisabled={
                  masterData?.sCategory?.toUpperCase() === "ALL" ? true : false
                }
                setValue={setMasterData}
                objName="sCategoryArr"
                label=""
                placeholder="Search Category"
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={2.5} sm={2} md={1} lg={1}>
              <CmpTypographyField xcomponent={"span"} xText={"Brand"} />
            </Grid>
            <Grid item xs={2} sm={2} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"11"}
                xLabelText="sBrand"
                xValue={masterData.sBrand}
                xOnChange={fBrand}
                xName={"sBrand"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>

            <Grid item xs={7.5} sm={8} md={6} lg={5}>
              <GCBrandSearch
                xValue={masterData?.sBrandSearchValue} //main input value
                xOnChange={(e) => {
                  setMasterData((obj) => ({
                    ...obj,
                    // sBrandArr: e.target.value,
                    sBrandSearchValue: e.target.value,
                  })); //main input onchange
                }}
                xReadOnly={
                  masterData?.sBrand?.toUpperCase() === "ALL" ? true : false
                }
                basketValue={masterData?.sBrandArr} //Search basket array
                xListValue={masterData?.sBrandArr
                  .map((x) => x.Name1)
                  .join(", ")} // 2nd main input
                onApply={(selectedObjects) => {
                  console.log("====================================");
                  console.log("selectedObjects", selectedObjects);
                  console.log("====================================");
                  setMasterData((obj) => ({
                    ...obj,
                    sBrandArr: selectedObjects,
                  }));
                  // setBrandBasket(selectedObjects) //array of object
                }} // <- handle selected names
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        pt={1}
        columnSpacing={1}
        columns={{ xs: 12, sm: 12, md: 12 }}
        className="ItmCdNameSearch"
      >
        <Grid item xs={2.5} sm={2} md={1} lg={1}>
          <CmpTypographyField xcomponent={"span"} xText={"Items"} />
        </Grid>
        <Grid item xs={0.5} sm={2} md={1} lg={1}></Grid>
        <Grid
          item
          xs={3.5}
          sm={3}
          md={2}
          lg={1.5}
          mt={vMediaQuery ? 1.5 : xMediaQuery ? 0 : 0}
        >
          <TextField
            label=""
            placeholder="Item Code"
            value={detailObj?.itemCode}
            onChange={(event) =>
              handleDetailChange("itemCode", event.target.value, event)
            }
            fullWidth
            error={errors?.itemCode === "" ? false : true}
            helperText={errors?.itemCode}
            disabled={true}
            autoComplete="off"
          />
        </Grid>
        <Grid
          item
          xs={5.5}
          sm={5}
          md={4}
          lg={3.5}
          mt={vMediaQuery ? 1.5 : xMediaQuery ? 0 : 0}
        >
          <GCToggleSearchV1
            xLabelText="Item Name"
            xtabIndex={"101"}
            xName={"B_ItmName"}
            xType={"text"}
            xValue={detailObj?.itemName}
            xReadOnly={false}
            xOnChange={(event) => {
              handleDetailChange("itemName", event.target.value);
            }}
            xOnKeyUp={fItemSearchKey}
            xonClickbtn={fItemSearchKey}
            xrows={sGridSelectRowData}
            xcolumns={[
              { field: "id", headerName: "ID", width: 70, hide: true },
              { field: "ItmCd", headerName: "ItmCd", width: 90 },
              { field: "Name1", headerName: "Name1", width: 450 },
              { field: "NameFL", headerName: "NameFL", width: 90 },
            ]} //head
            xRowCellClick={async (newSelectionModel, e) => {
              if (e.key === "Enter") {
                fGCToggleItemOnRowClick(newSelectionModel);
              }
            }}
            xRowClick={fGCToggleItemOnRowClick}
            xToggle={sItemToggleDropdown}
            xData={["Any", "Code", "Barcode", "Name", "RefNo", "NameFL"]}
            xOnChangeDropdownInput={fOnChangeItem}
            xDropdownObj={sItemSearchDropdownObj}
            xOnKeyUpDropdownInput={fOnKeyUpItem}
          />
        </Grid>
      </Grid>
      <Grid
        container
        textAlign={"center"}
        marginTop={vMediaQuery ? 1 : 0}
        columnSpacing={2}
      >
        {/* From Date */}
        <Grid item xs={6} sm={3} md={2} lg={1.5} marginTop={0.5}>
          <Typography sx={{ textAlign: "start" }}>From Date</Typography>
          <CmpDatePickerField001V1
            xLabelText=""
            xName={"dateFrom"}
            xValue={masterData?.dateFrom}
            xOnChange={(event) => {
              if (
                event?.$d == "Invalid Date" ||
                event?.$d == null ||
                event?.$d === undefined ||
                event?.$d === ""
              ) {
                setMasterData((obj) => ({
                  ...obj,
                  dateFrom: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1
                  ),
                }));
              } else {
                setMasterData((obj) => ({
                  ...obj,
                  dateFrom: event.$d,
                }));
              }
            }}
          />
        </Grid>

        {/* To Date */}
        <Grid item xs={6} sm={3} md={2} lg={1.5} marginTop={0.5}>
          <Typography sx={{ textAlign: "start" }}>To Date</Typography>
          <CmpDatePickerField001V1
            xLabelText=""
            xName={"dateTo"}
            xValue={masterData?.dateTo}
            xOnChange={(event) => {
              if (
                event?.$d == "Invalid Date" ||
                event?.$d == null ||
                event?.$d === undefined ||
                event?.$d === ""
              ) {
                setMasterData((obj) => ({
                  ...obj,
                  dateTo: new Date(),
                }));
              } else {
                setMasterData((obj) => ({
                  ...obj,
                  dateTo: event.$d,
                }));
              }
            }}
          />
        </Grid>

        {/* Checkbox and Buttons */}
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={5}
          textAlign="end"
          pt={2}
          marginTop={0.5}
        >
          <FormControlLabel
            sx={{
              "& .MuiCheckbox-root": {
                padding: vMediaQuery ? "0px !important" : "7px !important",
              },
            }}
            control={
              <Checkbox
                name="deleteInsert"
                checked={masterData?.deleteInsert === "Y"}
                onChange={() => {
                  handleCheckboxChange("deleteInsert");
                }}
              />
            }
            label="Delete & Insert"
          />

          <Button
            variant="contained"
            size="small"
            sx={{ marginRight: 1 }}
            onClick={() => {
              setRow([]);
              setSelectedRows([]);
              getCyclicCountItemGetRow();
            }}
          >
            Load
          </Button>

          <Button
            variant="contained"
            size="small"
            onClick={() => {
              if (row?.length > 0) {
                fSave();
              } else {
                fAlertToast("FAILED", "Grid should not be empty");
              }
            }}
            disabled={isEditing}
          >
            Save
          </Button>
        </Grid>
      </Grid>

      <Box
        sx={{
          mt: 2,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          height: "55vh",
          width: "100%",
        }}
      >
        <DataGridPro
          rowHeight={30}
          headerHeight={40}
          components={{
            Toolbar: GridToolbar,
          }}
          rows={row ? row : ""}
          getRowId={(v) => v.Id}
          columns={[
            {
              field: "Id",
              headerName: "ID",
              width: xMediaQuery ? 50 : 50,
              type: "number",
              align: "center",
              hide: true,
            },
            {
              field: "ItmCd",
              headerName: "Item Code",
              width: xMediaQuery ? 90 : 90,
            },
            {
              field: "Barcode",
              headerName: "Barcode",
              width: xMediaQuery ? 150 : 115,
              align: "center",
              type: "number",
            },
            {
              field: "ItemName",
              headerName: "Item Name",
              width: xMediaQuery ? 250 : 200,
              renderCell: (params) => (
                <div
                  style={{
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    lineHeight: "1.4em",
                  }}
                >
                  {params.value}
                </div>
              ),
            },
            {
              field: "UnitName",
              headerName: "Unit Name",
              width: xMediaQuery ? 90 : 90,
              align: "center",
            },
            {
              field: "PackQty",
              headerName: "Pack Qty",
              width: xMediaQuery ? 50 : 50,
              align: "center",
              type: "number",
            },
            {
              field: "SalesQty",
              headerName: "Sales Qty",
              width: xMediaQuery ? 50 : 50,
              align: "center",
              type: "number",
            },
            {
              field: "LPDate",
              headerName: "LPDate",
              width: xMediaQuery ? 90 : 90,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "StockQty",
              headerName: "Stock Qty",
              width: xMediaQuery ? 50 : 50,
              align: "center",
              type: "number",
            },
            {
              field: "CONSM",
              headerName: "CONSM",
              align: "center",
              width: xMediaQuery ? 60 : 60,
            },
            {
              field: "DisContinued",
              headerName: "Old",
              align: "center",
              width: 40,
              cellClassName: (params) =>
                params.row.DisContinued !== params.row.DisContinuedEdit
                  ? "cell-new"
                  : "",
            },
            {
              field: "DisContinuedEdit",
              headerName: "New",
              align: "center",
              width: 60,
              cellClassName: (params) =>
                params.row.DisContinued !== params.row.DisContinuedEdit
                  ? "highlight-cell"
                  : "",
              renderCell: (params) => (
                <Select
                  value={params.value || ""}
                  onChange={(e) =>
                    handleFieldEdit(params, e.target.value, "DisContinuedEdit")
                  }
                  onBlur={() => setIsEditing(false)}
                  onFocus={() => setIsEditing(true)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      const currentRowIndex = row.findIndex(
                        (row) => row.ItmCd === params.row.ItmCd
                      );
                      const nextRow = row[currentRowIndex + 1];
                      if (nextRow) {
                        const nextInput = document.querySelector(
                          `input[name="DisContinuedEdit-${nextRow.ItmCd}"]`
                        );
                        if (nextInput) nextInput.focus();
                      }
                    }
                  }}
                  displayEmpty
                  inputProps={{
                    name: `DisContinuedEdit-${params.row.ItmCd}`,
                  }}
                  fullWidth
                >
                  {yesNoOptions.map((opt) => (
                    <MenuItem key={opt.Uid} value={opt.Uid}>
                      {opt.Uid}
                    </MenuItem>
                  ))}
                </Select>
              ),
            },
            {
              field: "MainGroupName",
              headerName: "Main Group Name",
              align: "center",
              width: xMediaQuery ? 225 : 175,
            },
            {
              field: "SubGroupName",
              headerName: "Sub Group Name",
              align: "center",
              width: xMediaQuery ? 200 : 150,
            },
            {
              field: "CategoryName",
              headerName: "Category Name",
              align: "center",
              width: xMediaQuery ? 200 : 150,
            },
            {
              field: "Brand",
              headerName: "Brand",
              align: "center",
              width: xMediaQuery ? 150 : 110,
            },
            {
              field: "CreatedDate",
              headerName: "Created Date",
              width: xMediaQuery ? 90 : 90,
              align: "center",
              valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
            },
          ]}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          columnGroupingModel={columnGroupingModel}
          experimentalFeatures={{ columnGrouping: true }}
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
            "& .MuiDataGrid-cell": {
              padding: "0px 2px",
            },
            "& .MuiDataGrid-columnHeader": {
              whiteSpace: "normal",
              lineHeight: "1.2em",
              paddingTop: "8px",
              paddingBottom: "1px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              wordWrap: "break-word",
              fontSize: "11px", // Optional for better fit
            },
            "& .MuiDataGrid-columnHeaderTitleContainer": {
              textAlign: "center",
              justifyContent: "center",
            },
          }}
          // hideFooter={row?.length < 100}
          hideFooter={true}
          // onRowClick={(params) => handleRowClick(params.row)}
          checkboxSelection // Enables checkboxes
          disableSelectionOnClick // Prevents row selection when clicking inside a row
          // onSelectionModelChange={handleSelectionChange}
          selectionModel={selectedRows.map((row) => row.Id)}
          onCellEditStart={() => setIsEditing(true)}
          onCellEditStop={() => {
            setIsEditing(false);
          }}
          onCellEditCommit={() => setIsEditing(false)}
        />
      </Box>
      <CycleCustomModal
        open={searchModal}
        onClose={() => setSearchModal(false)}
        vMediaQuery={vMediaQuery}
        xMediaQuery={xMediaQuery}
        title="Item Search"
      >
        <ItemSearchModal
          open={searchModal}
          xMediaQuery={xMediaQuery}
          handleClose={() => setSearchModal(false)}
          handleRowClick={(item) => {
            setDetailObj((prev) => ({
              ...prev,
              itemCode: item.ItmCd,
              itemName: item.Name1,
            }));
            setErrors(initError);
            setSearchModal(false);
          }}
          location={HeadObject?.Head?.A_Location}
          anyDataItemName={detailObj?.itemName}
        />
      </CycleCustomModal>
    </Box>
  );
};

export default FilterModal;
